// ConfigAccessButton.js

const getPermissionValue = (permissionKey, subTabKey = null, buttonCategory = null, buttonKey = null) => {
  try {
    const loggedData = JSON.parse(localStorage.getItem("logged_data"));
    const userRole = loggedData?.data?.user_type || "";
    // Admin / co_admin always have access to action buttons
    if (userRole === "Admin" || userRole === "co_admin") {
      return true;
    }

    const userPermissions = loggedData?.data?.permissions || {};
    
    // Handle different permission types
    if (buttonCategory && buttonKey) {
      const permission = userPermissions[permissionKey];
      if (permission && permission.allowed === true && permission.sub_tabs) {
        const fullKey = `${buttonCategory}_${buttonKey}`;
        return permission.sub_tabs[fullKey] === true;
      }
      return false;
    } else if (subTabKey) {
      const permission = userPermissions[permissionKey];
      if (permission && permission.allowed === true && permission.sub_tabs) {
        return permission.sub_tabs[subTabKey] === true;
      }
      return false;
    } else {
      const permission = userPermissions[permissionKey];
      return permission && permission.allowed === true;
    }
  } catch (error) {
    console.error("Error reading permissions from localStorage:", error);
    return false;
  }
  // return true; // For testing purposes, return true for all permissions
};

// Define the complete button configuration structure
const BUTTON_CONFIGS = {
  "App Order": {
    "Placed Button": {
      advanced_export: getPermissionValue("appOrders", null, "Placed Button", "advanced_export"),
      update_status: getPermissionValue("appOrders", null, "Placed Button", "update_status"),
      update_payment: getPermissionValue("appOrders", null, "Placed Button", "update_payment"),
      send_email: getPermissionValue("appOrders", null, "Placed Button", "send_email")
    },
    "Confirmed Button": {
      update_status: getPermissionValue("appOrders", null, "Confirmed Button", "update_status"),
      update_payment: getPermissionValue("appOrders", null, "Confirmed Button", "update_payment"),
      // issend_email: getPermissionValue("appOrders", null, "Confirmed Button", "issend_email"),
      // confirmed_Button: getPermissionValue("appOrders", null, "Confirmed Button", "confirmed_Button"),
      advanced_export: getPermissionValue("appOrders", null, "Confirmed Button", "advanced_export"),
      send_email: getPermissionValue("appOrders", null, "Confirmed Button", "send_email")
    },
    "Processing Button": {
      advanced_export: getPermissionValue("appOrders", null, "Processing Button", "advanced_export"),
      update_status: getPermissionValue("appOrders", null, "Processing Button", "update_status"),
      update_payment: getPermissionValue("appOrders", null, "Processing Button", "update_payment"),
      send_email: getPermissionValue("appOrders", null, "Processing Button", "send_email"),
      generate_invoice_along_with_delivery_challan: getPermissionValue("appOrders", null, "Processing Button", "generate_invoice_along_with_delivery_challan")
    },
    "Dispatch Button": {
      advanced_export: getPermissionValue("appOrders", null, "Dispatch Button", "advanced_export"),
      update_status: getPermissionValue("appOrders", null, "Dispatch Button", "update_status"),
      update_payment: getPermissionValue("appOrders", null, "Dispatch Button", "update_payment"),
      send_email: getPermissionValue("appOrders", null, "Dispatch Button", "send_email"),
      view_invoice: getPermissionValue("appOrders", null, "Dispatch Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("appOrders", null, "Dispatch Button", "view_delivery_challan")
    },
    "Delivered Button": {
      advanced_export: getPermissionValue("appOrders", null, "Delivered Button", "advanced_export"),
      update_status: getPermissionValue("appOrders", null, "Delivered Button", "update_status"),
      update_payment: getPermissionValue("appOrders", null, "Delivered Button", "update_payment"),
      send_email: getPermissionValue("appOrders", null, "Delivered Button", "send_email"),
      view_invoice: getPermissionValue("appOrders", null, "Delivered Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("appOrders", null, "Delivered Button", "view_delivery_challan")
    },
    "Cancelled Button": {
      advanced_export: getPermissionValue("appOrders", null, "Cancelled Button", "advanced_export"),
      update_status: getPermissionValue("appOrders", null, "Cancelled Button", "update_status"),
      update_payment: getPermissionValue("appOrders", null, "Cancelled Button", "update_payment"),
      send_email: getPermissionValue("appOrders", null, "Cancelled Button", "send_email"),
      view_invoice: getPermissionValue("appOrders", null, "Cancelled Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("appOrders", null, "Cancelled Button", "view_delivery_challan")
    },
    "Returned Button": {
      advanced_export: getPermissionValue("appOrders", null, "Returned Button", "advanced_export"),
      update_status: getPermissionValue("appOrders", null, "Returned Button", "update_status"),
      update_payment: getPermissionValue("appOrders", null, "Returned Button", "update_payment"),
      send_email: getPermissionValue("appOrders", null, "Returned Button", "send_email"),
      view_invoice: getPermissionValue("appOrders", null, "Returned Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("appOrders", null, "Returned Button", "view_delivery_challan")
    }
  },
  "Agronomist": {
    "Pending Button": {
      update_status: getPermissionValue("talkToAgronomist", null, "Pending Button", "update_status")
    },
    "Connected Button": {
      update_status: getPermissionValue("talkToAgronomist", null, "Connected Button", "update_status")
    }
  },
  "Bulk Order": {
    "Placed Button": {
      advanced_export: getPermissionValue("bulkOrders", null, "Placed Button", "advanced_export"),
      update_status: getPermissionValue("bulkOrders", null, "Placed Button", "update_status"),
      update_payment: getPermissionValue("bulkOrders", null, "Placed Button", "update_payment"),
      send_email: getPermissionValue("bulkOrders", null, "Placed Button", "send_email"),
      bulk_upload: getPermissionValue("bulkOrders", null, "Placed Button", "bulk_upload")
    },
    "Confirmed Button": {
      advanced_export: getPermissionValue("bulkOrders", null, "Confirmed Button", "advanced_export"),
      update_status: getPermissionValue("bulkOrders", null, "Confirmed Button", "update_status"),
      update_payment: getPermissionValue("bulkOrders", null, "Confirmed Button", "update_payment"),
      send_email: getPermissionValue("bulkOrders", null, "Confirmed Button", "send_email"),
      bulk_upload: getPermissionValue("bulkOrders", null, "Confirmed Button", "bulk_upload")
    },
    "Processing Button": {
      advanced_export: getPermissionValue("bulkOrders", null, "Processing Button", "advanced_export"),
      update_status: getPermissionValue("bulkOrders", null, "Processing Button", "update_status"),
      update_payment: getPermissionValue("bulkOrders", null, "Processing Button", "update_payment"),
      send_email: getPermissionValue("bulkOrders", null, "Processing Button", "send_email"),
      bulk_upload: getPermissionValue("bulkOrders", null, "Processing Button", "bulk_upload"),
      generate_invoice_along_with_delivery_challan: getPermissionValue("bulkOrders", null, "Processing Button", "generate_invoice_along_with_delivery_challan")
    },
    "Dispatch Button": {
      advanced_export: getPermissionValue("bulkOrders", null, "Dispatch Button", "advanced_export"),
      update_status: getPermissionValue("bulkOrders", null, "Dispatch Button", "update_status"),
      update_payment: getPermissionValue("bulkOrders", null, "Dispatch Button", "update_payment"),
      send_email: getPermissionValue("bulkOrders", null, "Dispatch Button", "send_email"),
      view_invoice: getPermissionValue("bulkOrders", null, "Dispatch Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("bulkOrders", null, "Dispatch Button", "view_delivery_challan"),
      bulk_upload: getPermissionValue("bulkOrders", null, "Dispatch Button", "bulk_upload")
    },
    "Delivered Button": {
      advanced_export: getPermissionValue("bulkOrders", null, "Delivered Button", "advanced_export"),
      update_status: getPermissionValue("bulkOrders", null, "Delivered Button", "update_status"),
      update_payment: getPermissionValue("bulkOrders", null, "Delivered Button", "update_payment"),
      send_email: getPermissionValue("bulkOrders", null, "Delivered Button", "send_email"),
      view_invoice: getPermissionValue("bulkOrders", null, "Delivered Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("bulkOrders", null, "Delivered Button", "view_delivery_challan"),
      bulk_upload: getPermissionValue("bulkOrders", null, "Delivered Button", "bulk_upload")
    },
    "Cancelled Button": {
      advanced_export: getPermissionValue("bulkOrders", null, "Cancelled Button", "advanced_export"),
      update_status: getPermissionValue("bulkOrders", null, "Cancelled Button", "update_status"),
      update_payment: getPermissionValue("bulkOrders", null, "Cancelled Button", "update_payment"),
      send_email: getPermissionValue("bulkOrders", null, "Cancelled Button", "send_email"),
      view_invoice: getPermissionValue("bulkOrders", null, "Cancelled Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("bulkOrders", null, "Cancelled Button", "view_delivery_challan"),
      bulk_upload: getPermissionValue("bulkOrders", null, "Cancelled Button", "bulk_upload")
    },
    "Returned Button": {
      advanced_export: getPermissionValue("bulkOrders", null, "Returned Button", "advanced_export"),
      update_status: getPermissionValue("bulkOrders", null, "Returned Button", "update_status"),
      update_payment: getPermissionValue("bulkOrders", null, "Returned Button", "update_payment"),
      send_email: getPermissionValue("bulkOrders", null, "Returned Button", "send_email"),
      view_invoice: getPermissionValue("bulkOrders", null, "Returned Button", "view_invoice"),
      view_delivery_challan: getPermissionValue("bulkOrders", null, "Returned Button", "view_delivery_challan"),
      bulk_upload: getPermissionValue("bulkOrders", null, "Returned Button", "bulk_upload"),
      view: getPermissionValue("bulkOrders", null, "Returned Button", "view"),
      download: getPermissionValue("bulkOrders", null, "Returned Button", "download")
    }
  },
  "Return & Cancel Request": {
    "cancel request button": {
      accepted: getPermissionValue("returnCancelRequest", null, "cancel request button", "accepted"),
      rejected: getPermissionValue("returnCancelRequest", null, "cancel request button", "rejected")
    },
    "return request button": {
      accepted: getPermissionValue("returnCancelRequest", null, "return request button", "accepted"),
      rejected: getPermissionValue("returnCancelRequest", null, "return request button", "rejected")
    }
  },
  "Quotation/Proforma Invoice": {
    create_quotation_proforma: getPermissionValue("quotation", "create_quotation_proforma"),
    view_quotation_pdf: getPermissionValue("quotation", "view_quotation_pdf"),
    send_email: getPermissionValue("quotation", "send_email"),
    view_proforma_invoice: getPermissionValue("quotation", "view_proforma_invoice")
  },
  "Product Management": {
    add_product: getPermissionValue("agriStore", "add_product"),
    add_size: getPermissionValue("agriStore", "add_size"),
    add_stock: getPermissionValue("agriStore", "add_stock"),
    manage_companies_and_categories: getPermissionValue("agriStore", "manage_companies_and_categories"),
    manage_image: getPermissionValue("agriStore", "manage_image"),
    edit_product: getPermissionValue("agriStore", "edit_product"),
    delete_product: getPermissionValue("agriStore", "delete_product")
  },
  "Translation Management/Content": {
    add_translation: getPermissionValue("groceries", "add_translation"),
    edit: getPermissionValue("groceries", "edit"),
    delete: getPermissionValue("groceries", "delete")
  },
  "Post": {
    delete: getPermissionValue("farmerForum", "delete"),
    view_likes: getPermissionValue("farmerForum", "view_likes"),
    comment: getPermissionValue("farmerForum", "comment")
  },
  "Knowledge hub": {
    manage_categories: getPermissionValue("successStories", "manage_categories"),
    add_course: getPermissionValue("successStories", "add_course"),
    edit: getPermissionValue("successStories", "edit"),
    delete: getPermissionValue("successStories", "delete"),
    open: getPermissionValue("successStories", "open")
  },
  "Event Types": {
    create_event: getPermissionValue("eventType", "create_event"),
    update: getPermissionValue("eventType", "update"),
    edit: getPermissionValue("eventType", "edit"),
    delete: getPermissionValue("eventType", "delete")
  },
  "Crop types": {
    create_crop: getPermissionValue("cropType", "create_crop"),
    update: getPermissionValue("cropType", "update"),
    edit: getPermissionValue("cropType", "edit"),
    delete: getPermissionValue("cropType", "delete")
  },
  "Enquiry form": {
    enquiry_upload: getPermissionValue("enquiry", "enquiry_upload"),
    export_to_excel: getPermissionValue("enquiry", "export_to_excel")
  },
  "Field visit": {
    export_to_excel: getPermissionValue("fieldVisit", "export_to_excel"),
    view_image: getPermissionValue("fieldVisit", "view_image")
  },
  "Category": {
    add_category: getPermissionValue("category", "add_category"),
    edit: getPermissionValue("category", "edit"),
    delete: getPermissionValue("category", "delete")
  },
  "Crop hub": {
    add_crop: getPermissionValue("cropHub", "add_crop"),
    view: getPermissionValue("cropHub", "view"),
    edit: getPermissionValue("cropHub", "edit"),
    delete: getPermissionValue("cropHub", "delete")
  },
  "Disease Advisory": {
    "Categories Button": {
      add_category: getPermissionValue("diseaseAdvisory", null, "Categories Button", "add_category"),
      edit: getPermissionValue("diseaseAdvisory", null, "Categories Button", "edit"),
      delete: getPermissionValue("diseaseAdvisory", null, "Categories Button", "delete")
    },
    "Sub Categories Button": {
      add_category: getPermissionValue("diseaseAdvisory", null, "Sub Categories Button", "add_category"),
      edit: getPermissionValue("diseaseAdvisory", null, "Sub Categories Button", "edit"),
      delete: getPermissionValue("diseaseAdvisory", null, "Sub Categories Button", "delete")
    },
    "FAQs Button": {
      add_faqs: getPermissionValue("diseaseAdvisory", null, "FAQs Button", "add_faqs"),
      edit: getPermissionValue("diseaseAdvisory", null, "FAQs Button", "edit"),
      delete: getPermissionValue("diseaseAdvisory", null, "FAQs Button", "delete")
    }
  },
  "AI Chat bot": {
    add_questions: getPermissionValue("aiChatBot", "add_questions"),
    edit: getPermissionValue("aiChatBot", "edit"),
    delete: getPermissionValue("aiChatBot", "delete")
  },
  "Users": {
    add_user: getPermissionValue("users", "add_user"),
    edit: getPermissionValue("users", "edit"),
    delete: getPermissionValue("users", "delete")
  },
  "User Types & Permissions": {
    add_user_type: getPermissionValue("permissions", "add_user_type"),
    edit_permission: getPermissionValue("permissions", "edit_permission"),
    edit_user_type: getPermissionValue("permissions", "edit_user_type"),
    delete_user_type: getPermissionValue("permissions", "delete_user_type")
  },
  "FAQ": {
    faq_upload: getPermissionValue("FAQs", "faq_upload"),
    add_faq: getPermissionValue("FAQs", "add_faq"),
    edit_faq: getPermissionValue("FAQs", "edit_faq"),
    delete_faq: getPermissionValue("FAQs", "delete_faq")
  },
  "Report": {
    create: getPermissionValue("report", "create"),
    download: getPermissionValue("report", "download"),
    send_mail: getPermissionValue("report", "send_mail"),
    delete: getPermissionValue("report", "delete"),
    revenue_summary: getPermissionValue("report", "revenue_summary"),
    daily_summary: getPermissionValue("report", "daily_summary"),
    delivery_records: getPermissionValue("report", "delivery_records"),
    dashboard_report: getPermissionValue("report", "dashboard_report"),
    farmer_activity: getPermissionValue("report", "farmer_activity"),
  },
  "Support": {
    create: getPermissionValue("support", "create"),
    update: getPermissionValue("support", "update"),
    view: getPermissionValue("support", "view"),
    delete: getPermissionValue("support", "delete"),
    update_status: getPermissionValue("support", "update_status"),
    view_all: getPermissionValue("support", "view_all"),
  },
  "Transaction": {
    accepted: getPermissionValue("transaction", "accepted"),
    rejected: getPermissionValue("transaction", "rejected")
  }
};

// Export the config directly as a regular object (not a proxy)
const buttonConfig = BUTTON_CONFIGS;

/**
 * Support Feature action buttons (Create Request, Update, View, Delete).
 * Reads live permissions from localStorage on every call.
 * When create/update/view/delete keys exist in support.sub_tabs, they are enforced
 * for every role (including Admin) — same idea as Report Type filtering.
 */
export const isSupportButtonAllowed = (buttonKey) => {
  try {
    const loggedData = JSON.parse(localStorage.getItem("logged_data")) || {};
    const userRole = loggedData?.data?.user_type || "";
    const permissions = loggedData?.data?.permissions || {};
    const permission = permissions.support ?? permissions.Support;
    const key = String(buttonKey || "").toLowerCase().trim();
    const SUPPORT_CRUD_KEYS = ["create", "update", "view", "delete"];

    // No permissions loaded yet → Admin/co_admin only
    if (!permissions || Object.keys(permissions).length === 0) {
      return userRole === "Admin" || userRole === "co_admin";
    }

    if (!permission || permission === false) return false;

    // Legacy full-module grant (no button-level config)
    if (permission === true) return true;

    if (typeof permission !== "object" || permission.allowed !== true) return false;

    const subTabs = permission.sub_tabs || {};
    const hasGranularButtons = SUPPORT_CRUD_KEYS.some((k) =>
      Object.prototype.hasOwnProperty.call(subTabs, k)
    );

    // Button-level permissions configured → enforce for everyone (including Admin)
    if (hasGranularButtons) {
      if (subTabs[key] === true || subTabs[buttonKey] === true) return true;

      // Update Status inherits Update when update_status was never configured
      if (key === "update_status") {
        const hasExplicitUpdateStatus = Object.prototype.hasOwnProperty.call(
          subTabs,
          "update_status"
        );
        if (!hasExplicitUpdateStatus && subTabs.update === true) return true;
      }

      return false;
    }

    // Module allowed without button keys → full access (legacy)
    return true;
  } catch (error) {
    console.error("Error checking support button permission:", error);
    return false;
  }
};

const ORDER_STATUS_KEYS = new Set([
  "placed",
  "confirmed",
  "processing",
  "dispatch",
  "dispatched",
  "shipped",
  "delivered",
  "cancelled",
  "returned",
]);

/**
 * Status/sub-tab access for App Order & Bulk Order.
 * Denied statuses stay visible in the UI but should be rendered disabled.
 * Always reads live permissions from localStorage (not module-load-time config).
 */
export const isOrderStatusTabAllowed = (permissionKey, statusName) => {
  try {
    const loggedData = JSON.parse(localStorage.getItem("logged_data")) || {};
    const userRole = loggedData?.data?.user_type || "";
    const permissions = loggedData?.data?.permissions || {};
    const permission = permissions[permissionKey];
    const statusKey = String(statusName || "").toLowerCase().trim();

    // No permissions object: keep existing Admin/Company full-access behavior
    if (!permissions || Object.keys(permissions).length === 0) {
      return userRole === "Admin" || userRole === "co_admin" || userRole === "Company";
    }

    if (permission === true) return true;
    if (!permission || permission === false) return false;
    if (typeof permission !== "object" || permission.allowed !== true) return false;

    const subTabs = permission.sub_tabs || {};
    const configuredStatusKeys = Object.keys(subTabs).filter((key) =>
      ORDER_STATUS_KEYS.has(String(key).toLowerCase())
    );

    // Module allowed with only button permissions (no status keys) → all status tabs allowed
    if (configuredStatusKeys.length === 0) return true;

    const aliases = [statusKey];
    if (statusKey === "dispatched" || statusKey === "shipped") aliases.push("dispatch");
    if (statusKey === "dispatch") aliases.push("dispatched", "shipped");

    return aliases.some((key) => subTabs[key] === true);
  } catch (error) {
    console.error("Error checking order status tab permission:", error);
    return false;
  }
};

/**
 * Merge the full status-choices list with counts so denied statuses remain visible.
 * Backend count APIs may omit statuses the user cannot access.
 */
export const mergeOrderStatusLists = (allStatuses = [], countedStatuses = []) => {
  const countByName = {};
  countedStatuses.forEach((status) => {
    if (status?.name != null) {
      countByName[status.name] = status.count ?? 0;
    }
  });

  const countedNames = new Set(countedStatuses.map((status) => status?.name).filter(Boolean));
  const apiLooksFiltered =
    countedStatuses.length > 0 &&
    Array.isArray(allStatuses) &&
    allStatuses.length > countedStatuses.length;

  const merged = (Array.isArray(allStatuses) ? allStatuses : []).map((status) => ({
    ...status,
    count: countByName[status.name] ?? status.count ?? 0,
    // Backend omitted this status from the permitted count list
    omittedFromCountApi: apiLooksFiltered && !countedNames.has(status.name),
  }));

  // Include any count-only statuses not present in the full list
  countedStatuses.forEach((status) => {
    if (status?.name && !merged.some((item) => item.name === status.name)) {
      merged.push({
        ...status,
        count: status.count ?? 0,
        omittedFromCountApi: false,
      });
    }
  });

  return merged.sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
};

/** True when the status tab should be visible but not clickable. */
export const isOrderStatusTabDisabled = (permissionKey, status) => {
  const statusName = typeof status === "string" ? status : status?.name;
  const omittedFromCountApi = typeof status === "object" && !!status?.omittedFromCountApi;
  return !isOrderStatusTabAllowed(permissionKey, statusName) || omittedFromCountApi;
};

/**
 * Cancel Request / Return Request tab access on Return & Cancel Request page.
 * If button permissions exist for a tab category, that tab is enabled only when
 * at least one of those buttons is granted. Otherwise the tab stays allowed.
 */
export const isReturnCancelTabAllowed = (tabValue) => {
  try {
    const loggedData = JSON.parse(localStorage.getItem("logged_data")) || {};
    const userRole = loggedData?.data?.user_type || "";
    const permissions = loggedData?.data?.permissions || {};
    const permission = permissions.returnCancelRequest;

    if (!permissions || Object.keys(permissions).length === 0) {
      return userRole === "Admin" || userRole === "co_admin" || userRole === "Company";
    }

    if (permission === true) return true;
    if (!permission || permission === false) return false;
    if (typeof permission !== "object" || permission.allowed !== true) return false;

    const subTabs = permission.sub_tabs || {};
    const enabledKeys = Object.keys(subTabs).filter((key) => subTabs[key] === true);
    const allKeys = Object.keys(subTabs);
    const prefix =
      tabValue === "Cancelled" || tabValue === "cancel"
        ? "cancel request button"
        : "return request button";

    const hasCategoryConfigured = allKeys.some((key) =>
      String(key).toLowerCase().startsWith(prefix)
    );

    // No category-specific keys configured → tab remains available
    if (!hasCategoryConfigured) return true;

    return enabledKeys.some((key) => String(key).toLowerCase().startsWith(prefix));
  } catch (error) {
    console.error("Error checking return/cancel tab permission:", error);
    return false;
  }
};

const REPORT_TYPE_PERMISSION_KEYS = new Set([
  "revenue_summary",
  "daily_summary",
  "delivery_records",
  "dashboard_report",
  "farmer_activity",
]);

/**
 * Report Type dropdown access on Create Report.
 * Only report types explicitly set to true in report.sub_tabs are shown.
 * Reads live permissions from localStorage on every call.
 */
export const isReportTypeAllowed = (reportType) => {
  try {
    const loggedData = JSON.parse(localStorage.getItem("logged_data")) || {};
    const permissions = loggedData?.data?.permissions || {};
    const permission = permissions.report ?? permissions.Report;

    if (!permission || permission === false) return false;

    // Legacy full-module grant (no granular sub_tabs)
    if (permission === true) return true;

    if (typeof permission !== "object" || permission.allowed !== true) return false;

    const subTabs = permission.sub_tabs || {};
    const typeKey = String(reportType || "").toLowerCase().trim();

    // Case-insensitive map of granted flags
    const granted = {};
    Object.keys(subTabs).forEach((key) => {
      granted[String(key).toLowerCase()] = subTabs[key] === true;
    });

    const hasAnyReportTypeKey = [...REPORT_TYPE_PERMISSION_KEYS].some(
      (key) => Object.prototype.hasOwnProperty.call(granted, key)
    );

    // Report-type permissions are configured for this role → enforce them
    if (hasAnyReportTypeKey) {
      return granted[typeKey] === true;
    }

    // No report-type keys yet (legacy role) → allow all types
    return true;
  } catch (error) {
    console.error("Error checking report type permission:", error);
    return false;
  }
};

export default buttonConfig;